import { WorkPage } from "./Work";
export default WorkPage;
